import { component as defineComponent } from 'flightjs';

export default defineComponent(function() {
    this.attributes({
        select: '[data-styled-select-select]',
        option: '[data-styled-select-option]',
        label: '[data-styled-select-label]',
        count: '[data-styled-select-count]',
        filterNameAttr: 'data-styled-select-filter',
    });

    this.after('initialize', function() {
        this.on(document, 'uiBrowseFiltersUpdated', this.updateDisplay);

        this.on('change', {
            select: this.triggerBrowseFiltersUpdated,
        });
    });

    this.triggerBrowseFiltersUpdated = function() {
        var fieldName = this.$node.attr(this.attr.filterNameAttr);
        var fieldValue = this.select('select').val();
        var payload = {};

        if (this.$node.data('filterValue') !== fieldValue) {
            this.$node.data('filterValue', fieldValue);
            payload[fieldName] = fieldValue;
            this.trigger('uiBrowseFiltersUpdated', payload);
        }
    };

    this.getTitleByValue = function(value) {
        var title = '';
        this.select('option').each(function() {
            if ($(this).attr('value') === value) {
                title = $(this).attr('data-title');
            }
        });

        return title;
    };

    this.getCountByValue = function(value) {
        var count = '';
        this.select('option').each(function() {
            if ($(this).attr('value') === value) {
                count = $(this).attr('data-count');
            }
        });

        return count;
    };

    this.updateDisplay = function(e, data) {
        var field = this.$node.attr(this.attr.filterNameAttr);

        if (data.hasOwnProperty(field)) {
            this.select('select').val(data[field]);
            this.$node.data('filterValue', data[field]);
            this.select('label').text(this.getTitleByValue(data[field]));

            if (this.getCountByValue(data[field])) {
                this.select('count').text('(' + this.getCountByValue(data[field]) + ')');
            }
        }
    };
});



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/styled-select-filter.js